import { ApiService } from './ApiService';
import { TokenInfo } from '@/models/TokenInfo';

export class TokenService extends ApiService {

    public static SaveTokenLocal(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (token) {
            localStorage.setItem('token', token as string);
        }
    }

    private readonly resource: string = 'tokens';
    constructor() {
        super('v1');
    }

    public async GetInfo(): Promise<TokenInfo> {
        return this.Get(TokenInfo, this.resource);
    }

    public SaveTokenLocal(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        localStorage.setItem('token', token as string);
    }
}
